<template>
  <div class="row one-tariff mb-2" v-on:click="selectTariff()">
    <div class="col-8 align-self-center pl-1">
      <div class="row name">
        {{ name }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PaymentMethod',
  props: ['percent', 'name', 'tariffId', 'payOrder'],
  data () {
    return {}
  },
  methods: {
    selectTariff: function () {
      this.payOrder(this.tariffId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.one-tariff {
  cursor: pointer;
  color: #525960;
  height: 85px;
  background: white;
  border-radius: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

@media (max-width: 767px) {
  .one-tariff {
    width: 330px;
    height: 105px;
  }

  .one-tariff .price {
    font-size: 24px;
    line-height: 22px
  }
}

@media (min-width: 767px) {
  .one-tariff {
    width: 365px;
  }

  .one-tariff .price {
    font-size: 32px;
    line-height: 22px
  }

}

.one-tariff .name {
  font-weight: bold;
}

.one-tariff .discount {
  font-size: 14px;
  background: #27A9CA;
  border-radius: 15px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.one-tariff .price .currency {
  font-size: 14px;
}
</style>
